<template>
<v-autocomplete
  ref="autocomplete"
  v-model="innerValue"
  :items="items"
  item-text="DisplayText"
  item-value="ID"
  return-object
  filled
  hide-no-data
  :menu-props="{ maxHeight: 500 }"
  v-bind="$attrs"
  v-on="$listeners"
  class="abr-grid-autocomplete"
  @change="onChange"
>

    <!-- Header -->
    <template v-slot:prepend-item>
      <div class="grid-header">
        <div class="col-radio"></div>
        <div class="col">شماره بیمه نامه</div>
        <div class="col">نام بیمه شده</div>
        <div class="col">کد ملی</div>
        <div class="col">بیمه گزار</div>
      </div>
    </template>

    <!-- Rows -->
    <template v-slot:item="{ item }">
      <div
        class="grid-row"
        :class="{ selected: innerValue === item.ID }"
      >
        <div class="col-radio">
          <v-radio
            v-model="innerValue"
            :value="item.ID"
            hide-details
          ></v-radio>
        </div>
        <div class="col">{{ item.PolicyNo }}</div>
        <div class="col">{{ item.FullName }}</div>
        <div class="col">{{ item.NationalNo }}</div>
        <div class="col">{{ item.MainPolicyHolderName }}</div>
      </div>
    </template>

  </v-autocomplete>
</template>

<script>
export default {
  props: ["def", "model"],
  data() {
    return {
 innerValue: null    }
  },
  computed: {
    items() {
      return this.$parent.lookupItems || []
    }
  },
  methods: {
  onChange(item) {
    if (!item) return;
    this.$set(this.model, "RiskID", item.ID)
    this.$parent.fillAdditional(item, true)
  }
  }
}
</script>

<style scoped>
.abr-grid-autocomplete {
  border-radius: 8px;
  box-shadow: none;
}

.abr-grid-autocomplete >>> .v-input,
.abr-grid-autocomplete >>> .v-input__slot,
.abr-grid-autocomplete >>> .v-input__control {
  box-shadow: none !important;
  padding-bottom: 0 !important;
}

.abr-grid-autocomplete >>> .v-input.v-input--is-focused,
.abr-grid-autocomplete >>> .v-input:hover {
  border-bottom: 1px solid #999 !important;
}

.abr-grid-autocomplete >>> .v-list,
.abr-grid-autocomplete >>> .v-select-list .v-list {
  margin: 0 !important;
  padding: 0 !important; 
}

.abr-grid-autocomplete >>> .v-list-item {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.v-autocomplete .v-list {
  overflow-x: auto;
}

.grid-header, .grid-row {
  display: grid;
  grid-template-columns: 40px 1.5fr 2fr 1.5fr 1.5fr; 
  align-items: center;
  padding: 4px 12px;
  border-bottom: 1px solid #eee;
  width: 100%; 
  box-sizing: border-box;
}

.col {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.grid-header {
  font-weight: 600;
  background-color: #f8f6f6;
}

.grid-row:hover {
  background-color: #f0f0f0;
}

.grid-row.selected {
  background-color: #d0ebff;
}

.col-radio {
  display: flex;
  justify-content: center;
  align-items: center;
}


</style>
